import { render, staticRenderFns } from "./reviewPlan.vue?vue&type=template&id=bfe9c856&scoped=true"
import script from "./reviewPlan.vue?vue&type=script&lang=js"
export * from "./reviewPlan.vue?vue&type=script&lang=js"
import style0 from "./reviewPlan.vue?vue&type=style&index=0&id=bfe9c856&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe9c856",
  null
  
)

export default component.exports